"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveDatabaseCellStorageKey = resolveDatabaseCellStorageKey;
/** Resolve historical CRUD title cells without overwriting declared values. */
function resolveDatabaseCellStorageKey(cells, propertyId, columns) {
    if (Object.prototype.hasOwnProperty.call(cells, propertyId))
        return propertyId;
    const titles = columns.filter(column => column.type === 'title');
    if (titles.length === 1 &&
        titles[0].id === propertyId &&
        !columns.some(column => column.id === 'title' && column.type !== 'title') &&
        Object.prototype.hasOwnProperty.call(cells, 'title'))
        return 'title';
    return propertyId;
}
